import React, { memo, useCallback, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, Popup, UiButton } from '@shared/ui';

import { ModalBodyCustomer } from './ModalBodyCustomer/ModalBodyCustomer';
import cls from './ModalCustomer.module.css';
import { useModalCustomer } from './useModalCustomer';
import { Tabs } from '../../../../components/newUI/Tabs/Tabs';
import { Loader } from '../../../../components/UI/NewLoader/Loader/Loader';

interface ModalCustomerProps {
    classes?: string;
}

export const ModalCustomer = memo(({ classes }: ModalCustomerProps) => {
    const {
        onCancel,
        modalMode,
        onForm,
        form,
        customerModalLoader,
        editLoader,
        onSubmit,
        errorValidate,
        onDelete,
        isError,
        isShowPopup,
        onHidePopup,
        onClickDelete,
    } = useModalCustomer();

    const { t } = useTranslation();

    const tabsList = [
        {
            title: t('ModalCustomer.tabsList.value.general'),
            value: 'general',
        },
        {
            title: t('ModalCustomer.tabsList.value.requisites'),
            value: 'requisites',
        },
    ];

    const [activeTab, setActiveTab] = useState('general');
    const onTabChange = useCallback((value: string) => {
        setActiveTab(value);
    }, []);

    return (
        <>
            <Popup
                isOpen={isShowPopup}
                onHidePopup={onHidePopup}
                btnActionCb={onDelete}
                type="delete"
                deleteButtonText={t('ModalCustomer.return.popup.danger')}
                cancelButtonText={t('ModalCustomer.return.popup.cancel')}
                popupContentClassName={cls.secondModal}
                contentText={t('ModalCustomer.return.popup.text')}
            />
            <CustomModal
                contentClasses={cls.ModalCustomer}
                isOpen={modalMode === 'addCustomer' || modalMode === 'editCustomer'}
                onHideModal={onCancel}
            >
                {(editLoader || customerModalLoader) && <Loader variant="light" />}
                <CustomModal.Header classes={cls.ModalHeader}>
                    {t('ModalCustomer.return.modalHeader')}
                    <Tabs
                        classes={cls.tabs}
                        onChange={onTabChange}
                        tabsList={tabsList}
                        activeTab={activeTab}
                        errorTabs="general"
                        isError={isError}
                    />
                </CustomModal.Header>
                <CustomModal.Body>
                    <ModalBodyCustomer
                        activeTab={activeTab}
                        onForm={onForm}
                        form={form}
                        errorValidate={errorValidate}
                        isError={isError}
                    />
                </CustomModal.Body>
                <CustomModal.Footer>
                    <Flex justify="between" fullWidth>
                        {modalMode === 'editCustomer' ? (
                            <UiButton
                                btnColor="danger"
                                onClick={onClickDelete}
                                btnText={t('ModalCustomer.return.modalFooter.delete')}
                            />
                        ) : (
                            <UiButton
                                btnColor="secondary"
                                onClick={onCancel}
                                btnText={t('ModalCustomer.return.modalFooter.cancel')}
                            />
                        )}
                        <UiButton
                            onClick={onSubmit}
                            btnText={t('ModalCustomer.return.modalFooter.submit')}
                        />
                    </Flex>
                </CustomModal.Footer>
            </CustomModal>
        </>
    );
});
